var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Instagram"),React.createElement("g",{"fill":"currentColor","transform":"translate(-12 -12)","key":1},[React.createElement("circle",{"cx":"24.1","cy":"15.9","r":"1","key":0}),React.createElement("path",{"d":"M20 24c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z","key":1}),React.createElement("path",{"d":"M24 28h-8c-2.1 0-4-1.9-4-4v-8c0-2.1 1.9-4 4-4h8c2.1 0 4 1.9 4 4v8c0 2.1-1.9 4-4 4zm-8-14c-.9 0-2 1.1-2 2v8c0 1 1 2 2 2h8c.9 0 2-1.1 2-2v-8c0-.9-1.1-2-2-2h-8z","key":2})])]);
}

Instagram.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = Instagram;

Instagram.default = Instagram;
